import {observer} from 'mobx-react-lite'
import React, {useContext} from 'react'
import {DataObjectId} from 'yougile-model'
import {Checkbox} from '@components/common/base/checkbox'
import {Icon} from '@components/common/icon/icon'
import {multiActionsWithTasksStore} from '@components/multi-actions-with-tasks/multi-actions-with-tasks-store'
import {PropsContext, useUsersTableStore} from '../users-table-store'
import {UsersTableUtil} from '../users-table-util'

export const UserCheckbox = observer(({userId}: {userId: DataObjectId}) => {
  const [state, store] = useUsersTableStore()
  const props = useContext(PropsContext)
  const userSelected =
    state.toggle && multiActionsWithTasksStore.state.visible
      ? UsersTableUtil.allSelected(userId, state.tasksOnUser)
      : state.selected.has(userId)
  const onClick = () => {
    store.toggleTurnOff()
    store.toggleSelected(userId)
    props.onToggled?.([userId])
    props.onSelectedChanged?.([...state.selected])
  }
  if (props.useCheckbox) {
    return <Checkbox onChange={onClick} stopPropagation value={userSelected} />
  }
  return (
    <div onClick={onClick}>
      {userSelected ? (
        <>
          <Icon
            onClick={onClick}
            className="cursor-pointer group-hover:hidden"
            name="tick"
          />
          <Icon
            onClick={onClick}
            className="hidden cursor-pointer group-hover:block"
            name="untick"
          />
        </>
      ) : (
        <Icon
          onClick={onClick}
          className="hidden cursor-pointer group-hover:block"
          name="tick-gray"
        />
      )}
    </div>
  )
})
